module.exports = __webpack_public_path__ + "media/images/animations/overhight_load/2-726f4553ef6a128ea0017f49d0a532d8.png";